<template>
  <div>
    <event-registry-versions-widget :contractId="contractId" @clickedOnVersion="openVersion" />
  </div>
</template>
<script>
export default {
  computed: {
    contractId() {
      return this.$route.params.id;
    }
  },
  methods: {
    openVersion({ id, eventId }) {
      let routeData = this.$router.resolve({
        name: "AssetsEdit",
        params: { id: id },
        query: { eventId: eventId }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
